import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1 } from 'approot/shared/styles/colours.style';

export const TeachingLearningSequenceGuestGradient = styled.div`
  position: relative;

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: ${rem(120)};
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0), ${grey1});
  }
`;
